import { Navigate, useRoutes } from "react-router-dom";
import MainLayout from "./layouts/mainLayout";
import Home from "./pages/home";
import GameList from "./pages/gameList";
import MyMarkets from "./pages/profilePages/myMarkets";
import Racing from "./pages/racing";
import GameDetail from "./pages/gameDetails";
import MyBets from "./pages/profilePages/myBets";
import BettingPnL from "./pages/profilePages/bettingPnL";
import TransferStatement from "./pages/profilePages/transferStatement";
import TimeSettings from "./pages/profilePages/timeSettings";
import ChangePassword from "./pages/profilePages/changePassword";
import RulesAndRegs from "./pages/miscPages/rulesAndRegs";
import Kyc from "./pages/miscPages/kyc";
import ResponsibleGambling from "./pages/miscPages/responsibleGambling";
import ExclusionPolicy from "./pages/miscPages/exclusionPoliciy";
import Settings from "./pages/profilePages/settings";
import LeagueEvents from "./pages/leagueEvents";
import LiveCasino from './pages/liveCasino';
import { useDispatch, useSelector } from "react-redux";
import userSocket from "./services/userSocket";
import { useEffect, useState } from "react";
import { eventConnected, eventDisconnected, oddsConnected, oddsDisconnected, userConnected, userDisconnected } from "./redux/reducers/socket";
import { updateBalanceDetails } from "./redux/reducers/user";
import eventSocket from "./services/eventSocket";
import SportBook from "./pages/profilePages/sportbook";
import sportSocket from "./services/sportSocket";
import socketServices from "./services/socketServices";
import authServices from "./services/authServices";
import fancySocketServices from "./services/fancySocketServices";


export default function Router()
{
    const { isLogginIn } = useSelector(state=>state.user);
    const dispatch = useDispatch();

    useEffect(()=>{
        if(isLogginIn){
            getBalanceFromApi();
            dispatch(userDisconnected());
            dispatch(oddsDisconnected());
            dispatch(eventDisconnected())
            socketServices.connect(handleOddsConnection);
            fancySocketServices.connect(()=>{});
            // console.log(user.user_id)
           
            // userSocket.chekUserConnected(handleConnection)
            // userSocket.getBalanceData(setBalanceData);
            // eventSocket.connect(handleEventConnection);
            // sportSocket.connect(()=>{});
        }
    },[isLogginIn])

    const getBalanceFromApi = async()=>{
        try {
            const res = await authServices.getBalance();
            if(res){
                setBalanceData(res);
            }
        } catch (error) {
            
        }
    }

    const handleConnection = (connected) =>{
        if(connected){
            // console.log("sfkldjflikdjslik")
            userSocket.joinUser();
            dispatch(userConnected())
        }
        else{
            dispatch(userDisconnected());
        }
    }
    const handleOddsConnection = (connected) =>{
        if(connected){
            dispatch(oddsConnected())
            // setTimeout(()=>{
                sportSocket.connect(()=>{});
                eventSocket.connect(handleEventConnection);
                userSocket.connect(handleConnection);
                userSocket.getBalanceData((data)=> dispatch(updateBalanceDetails(data)));
                
            // },2000)
        }
        else{
            dispatch(oddsDisconnected());
        }
    }

    const handleEventConnection = (connected) =>{
        if(connected){
            dispatch(eventConnected())
        }
        else{
            dispatch(eventDisconnected());
        }
    }
    
    const setBalanceData = (data) =>{
        dispatch(updateBalanceDetails(data))
    }

    return useRoutes([
        {
            path:"",
            element:<MainLayout />,
            children:[
                {
                    path:"",
                    element:<Home/>
                },
                {
                    path:"sport/:sportId",
                    element:<GameList/>,
                },
                {
                    path:"sport/:sportId/league/:leagueId",
                    element:<LeagueEvents/>,
                },
                {
                    path:"sport/:sportId/game-details/:eventId",
                    element:<GameDetail />
                },
                {
                    path:"my-markets",
                    element:<MyMarkets/>
                },
                {
                    path:"racing/:sportId",
                    element:<Racing/>
                },
                {
                    path:"settings",
                    element:<Settings/>
                },
                {
                    path:"my-bets",
                    element:<MyBets/>
                },
                {
                    path:"betting-pnl",
                    element:<BettingPnL/>
                },
                {
                    path:"betting-pnl/:marketId",
                    element:<BettingPnL/>
                },
                {
                    path:"transfer",
                    element:<TransferStatement/>
                },
                {
                    path:"time-settings",
                    element:<TimeSettings/>
                },
                {
                    path:"change-password",
                    element:<ChangePassword/>
                },
                {
                    path:"rules-regs",
                    element:<RulesAndRegs />
                },
                {
                    path:"kyc",
                    element:<Kyc />
                },
                {
                    path:"responsible-gambling",
                    element:<ResponsibleGambling />
                },
                {
                    path:"exclusion-policy",
                    element:<ExclusionPolicy />
                },
            ]
        },
        {
            path:"live-casino",
            element:<LiveCasino />,
        },
        {
            path:"live-casino/tab/:tabId",
            element:<LiveCasino />,
        },
        {
            path:"live-casino/tab/:tabId/:game_id",
            element:<LiveCasino />,
        },
        {
            path:"live-casino/:game_id",
            element:<LiveCasino />,
        },
        {
            path:"sportbook",
            element:<SportBook/>
        },
        {
            path:"*",
            element:<Navigate to=""/>
        },
    ],)
}